/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Col_Unit_CostInputs */

const en_po_col_unit_cost = /** @type {(inputs: Po_Col_Unit_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit cost`)
};

/**
* | output |
* | --- |
* | "Unit cost" |
*
* @param {Po_Col_Unit_CostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_col_unit_cost = /** @type {((inputs?: Po_Col_Unit_CostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Col_Unit_CostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_col_unit_cost(inputs)
});